// extracted by mini-css-extract-plugin
module.exports = {"updateActionButton":"EditFlag_updateActionButton__1T390"};